<template>
  <div id="AccountShopLinks" class="Main-Content">

    <LoadingLayout v-if="loading" :page="true" />

    <Page
      v-else
      :title="$t('Linked Store')"
    >
    
      <Layout>
        <LayoutSection>
          <Card :title="$t('Linked Store Details')">
            <CardSection>
              <TextContainer>
                <p>{{ $t('AccountShopLinks.infoText') }}</p>
                <p>{{ $t('Account Key') }}: {{ account.key }}</p>
                <template v-if="shopLink">
                  <p>{{$t('AccountShopLinks.Secret')}}: {{ shopLink.apiKey }}</p>
                  <p>{{$t('AccountShopLinks.shopID')}}: {{ shopLink.id }}</p>
                </template>
              </TextContainer>
            </CardSection>
          </Card>
        </LayoutSection>
      </Layout>
    
    </Page>

  </div>
</template>

<script>

export default {
  name: 'AccountShopLinks',
  data () {
    return {
      loading: true,
      account: null,
      shopLink: null,
    }
  },
  mounted() {
    NProgress.start()
    Promise.all([this.api.getAccountForShopLinks(), this.api.getShopLink()])
      .then((response) => {
        let [ account, shopLink ] = response
        this.shopLink = shopLink
        this.account = account
        this.loading = false
      })
      .catch(this.apiCatch)
      .finally(() => {
        NProgress.done()
      })
  },
}

</script>

<style lang="scss">
</style>
